<template>
  <div class="w-full">
    <div
      class="p-4 bg-grey-lighter font-medium flex flex-1 flex-row border-t border rounded-t"
    >
      <div class="w-full flex font-bold">
        <div class="w-1/6 mr-2">
          <div>Title</div>
        </div>
        <div class="w-5/6 flex">
          <div class="w-1/5 mr-2">Holiday Starts</div>
          <div class="w-1/5 mr-2">Holiday Ends</div>
          <div class="w-1/5 mr-2 text-center">Full Day Closed?</div>
          <div class="w-1/5 mr-2">Opening Hours</div>
          <div class="w-1/5 mr-2">Closing Hours</div>
        </div>
      </div>
    </div>
    <pt-list v-if="data.length">
      <pt-list-item
        v-for="(specialHoliday, index) in data"
        :key="index"
        class="flex pt-list-cursor-default"
      >
        <!-- <list-row
          :info="specialHoliday"
          @deleteItem="deleteItem"
          @editItem="editItem"
        /> -->

        <div class="w-full flex p-4">
          <div class="w-1/6 mr-2 break-words">
            {{ specialHoliday.name }}
          </div>
          <div class="w-5/6 flex">
            <div class="w-1/5 mr-2">{{ getDate(specialHoliday.start_date) }}</div>
            <div class="w-1/5 mr-2">{{ getDate(specialHoliday.end_date) }}</div>
            <div class="w-1/5 mr-2 text-center">
              <span :class="fullDayClosedStyle(specialHoliday)">
                {{ isFullDayClosedText(specialHoliday) }}
              </span>
            </div>
            <div class="w-1/5 mr-2">{{ getTime(specialHoliday.opening_time) }}</div>
            <div class="w-1/5 mr-2">{{ getTime(specialHoliday.closing_time) }}</div>
          </div>
        </div>

      </pt-list-item>
    </pt-list>
  </div>
</template>

<script>
import { PtList, PtListItem } from '@pathao/ui-components/esm/List';
import formatDate from '@src/utils/format-date';
import formatTime from '@src/utils/format-time';

export default {
  name: 'OverlappedHolidays',
  components: { PtList, PtListItem },
  props: {
    data: {
      type: Array,
      default: null,
    },
  },
  methods: {
    getDate(date) {
      return formatDate(date, 'DD/MM/YYYY');
    },
    getTime(date) {
      return date ? formatTime(date) : '';
    },
    fullDayClosedStyle(info) {
      return info.is_full_day_closed ? 'success-status rounded px-4 py-1' : 'failed-status rounded px-4 py-1';
    },
    isFullDayClosedText(info) {
      return info.is_full_day_closed ? 'YES' : 'NO';
    },
  },
};
</script>
